import { render, staticRenderFns } from "./SupportDetail.vue?vue&type=template&id=5a01c532&"
import script from "./SupportDetail.vue?vue&type=script&lang=js&"
export * from "./SupportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports